/**
 * Icon wrapper component
 * Provides a drop-in replacement for FontAwesomeIcon that uses react-icons
 */

import React from "react";
import { getFaIcon } from "../../assets/icons";

/**
 * Icon component - compatible with FontAwesomeIcon API
 * @param {string} icon - Icon name (can be fa-* string or component)
 * @param {string} className - CSS class names
 * @param {string} size - Icon size (xs, sm, md, lg, xl) or px value
 * @param {boolean} spin - Animate icon with spinning animation
 * @param {any} rest - Other props
 * @returns {JSX.Element}
 */
export const Icon = ({ icon, className = "", size, spin = false, ...rest }) => {
  // Map size values to pixel sizes
  const sizeMap = {
    xxs: 10,
    xs: 14,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
    "2xl": 40,
  };

  // Convert size to pixel value if it's a named size
  const iconSize = sizeMap[size] || size;

  // Build className with spin animation
  const finalClassName = [className, spin && "spin"].filter(Boolean).join(" ");

  // If icon is already a component, use it
  if (typeof icon === "function") {
    return icon({ className: finalClassName, size: iconSize, ...rest });
  }

  // If it's a string, map it using getFaIcon
  const IconComponent = getFaIcon(icon);

  return <IconComponent className={finalClassName} size={iconSize} {...rest} />;
};

export default Icon;
